<script setup lang="ts">
import type { TooltipRootEmits, TooltipRootProps } from 'reka-ui';
import { TooltipRoot, useForwardPropsEmits } from 'reka-ui';

defineOptions({
    name: 'UiTooltip',
});

const props = withDefaults(defineProps<TooltipRootProps>(), {
    delayDuration: 100,
    disableHoverableContent: true,
});
const emits = defineEmits<TooltipRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
    <TooltipRoot v-bind="forwarded">
        <slot />
    </TooltipRoot>
</template>
